import { z } from "zod";
import { now } from "../date-time/date-time";
import { isoAndUnixZodSchema } from "../date-time/iso-and-unix";
import { iconNameZodString } from "../icon-name";
import { productIdZodSchema } from "../products/product-id";
import { providerIdZodSchema } from "../providers/provider-id";
import { hexColorZodSchema } from "../stylable/hex-color/hex-color";
import { requiredTranslatableZodSchema } from "../translations/translation";
import { labelIdFactory, labelIdZodSchema } from "./label-id";

const labelReferencesZodObject = z.array(
    z.union([
        providerIdZodSchema,
        productIdZodSchema,
        // field ids ...
    ]),
);

const labelZodObject = z.object({
    _id: labelIdZodSchema,
    _type: z.literal("LABEL"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema.nullable(),
    title: requiredTranslatableZodSchema,
    value: z.string().toLowerCase().min(1),
    iconName: iconNameZodString.optional(),
    color: hexColorZodSchema.optional(),
    references: labelReferencesZodObject,
});

type Label = z.infer<typeof labelZodObject>;

const factoryParamsZodObject = labelZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof factoryParamsZodObject>;

const labelFactory = (input: FactoryParams): Label => {
    return {
        ...input,
        _id: labelIdFactory(),
        _type: "LABEL",
        _createdAt: now(),
    };
};

export {
    labelFactory,
    factoryParamsZodObject as labelFactoryParamsZodObject,
    labelZodObject,
};
export type { Label, FactoryParams as LabelFactoryParams };
